import LegalShell, { Section, MailLink } from "@/components/LegalShell";

export default function About() {
  return (
    <LegalShell kicker="About" title="About Astra — Horoscope & Birth Chart" testId="about-page" path="/about" docTitle="About Astra · Horoscope & Birth Chart">
      <p>Astra is a precision astrology platform built by the team behind Astra - Free Daily Horoscope. Our mission is to make astronomy-based astrology accessible and consistent.</p>
      <Section title="How it works">
        <p>Every reading starts with where the planets actually are today. We calculate real planetary positions using PyEphem / VSOP87 ephemeris — a proven astronomical ephemeris. We currently publish Western tropical charts only.</p>
        <p>On top of that calculation sits Astra, powered by Anthropic's Claude, guided by detailed astrology instructions to interpret the chart. Claude does not invent planetary positions — it interprets the positions we calculate.</p>
      </Section>
      <Section title="Human review">
        <p>Daily readings publish automatically from our calculated positions. Our editorial process includes regular spot-checks, review of weekly and monthly readings, and review of templates and instructions. We publish 36 core sections daily (12 signs x daily + love + money), plus 12 weekly and 12 monthly readings.</p>
        <p>Astra is for self-reflection and entertainment, not professional advice.</p>
      </Section>
      <Section title="Contact">
        <p>Contact: <MailLink /></p>
      </Section>
    </LegalShell>
  );
}
